import locales from './locale/index.js';
import locale from './locale/en-AU.js';
import vuetifyLanguages from './VuetifyLanguages.js';
import './captions/index.js';
import DefaultDateFormatter from './formatters/DefaultDateFormatter.js';
import DefaultDateRangeFormatter from './formatters/DefaultDateRangeFormatter.js';
import DefaultDateTimeFormatter from './formatters/DefaultDateTimeFormatter.js';
import DefaultDateTimeFormatter$1 from './formatters/DefaultDurationFormatter.js';
import DefaultDateTimeMethods from './formatters/DefaultDateTimeMethods.js';
import DefaultTimeFormatter from './formatters/DefaultTimeFormatter.js';
import Captions from './captions/Captions.js';

class Language {
  constructor(vuetify, options) {
    var _a;
    this._vuetify = vuetify;
    this._options = options;
    this._current = (_a = options === null || options === void 0 ? void 0 : options.current) !== null && _a !== void 0 ? _a : 'en-AU';
    this.captions = new Captions(options === null || options === void 0 ? void 0 : options.captionProvider);
    this.clearFormatters();
  }
  get current() {
    return this._current;
  }
  set current(value) {
    this._current = value;
    this._vuetify.framework.lang.current = vuetifyLanguageFromCode(value);
    this.clearFormatters();
  }
  set numericLocale(numericLocale) {
    this._numericLocale = numericLocale;
  }
  get locale() {
    var _a;
    const originalLocale = (_a = locales[this.current.toLowerCase()]) !== null && _a !== void 0 ? _a : locale;
    return Object.assign(Object.assign({}, originalLocale), this._numericLocale);
  }
  get supportedLocales() {
    return locales;
  }
  get dateFormatter() {
    var _a, _b;
    if (!this._dateFormatter) {
      this._dateFormatter = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.dateFormatter) !== null && _b !== void 0 ? _b : new DefaultDateFormatter(this.current, this.locale);
    }
    return this._dateFormatter;
  }
  get dateRangeFormatter() {
    var _a, _b;
    if (!this._dateRangeFormatter) {
      this._dateRangeFormatter = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.dateRangeFormatter) !== null && _b !== void 0 ? _b : new DefaultDateRangeFormatter(this.current, this.locale);
    }
    return this._dateRangeFormatter;
  }
  get dateTimeFormatter() {
    var _a, _b;
    if (!this._dateTimeFormatter) {
      this._dateTimeFormatter = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.dateTimeFormatter) !== null && _b !== void 0 ? _b : new DefaultDateTimeFormatter(this.current, this.locale);
    }
    return this._dateTimeFormatter;
  }
  get dateTimeMethods() {
    var _a, _b;
    if (!this._dateTimeMethods) {
      this._dateTimeMethods = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.dateTimeMethods) !== null && _b !== void 0 ? _b : new DefaultDateTimeMethods(this.current);
    }
    return this._dateTimeMethods;
  }
  get durationFormatter() {
    var _a, _b;
    if (!this._durationFormatter) {
      this._durationFormatter = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.durationFormatter) !== null && _b !== void 0 ? _b : new DefaultDateTimeFormatter$1();
    }
    return this._durationFormatter;
  }
  get timeFormatter() {
    var _a, _b;
    if (!this._timeFormatter) {
      this._timeFormatter = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.timeFormatter) !== null && _b !== void 0 ? _b : new DefaultTimeFormatter(this.current, this.locale);
    }
    return this._timeFormatter;
  }
  clearFormatters() {
    this._dateFormatter = undefined;
    this._dateRangeFormatter = undefined;
    this._dateTimeFormatter = undefined;
    this._dateTimeMethods = undefined;
    this._durationFormatter = undefined;
    this._timeFormatter = undefined;
  }
  static toVuetifyLangOptions(options) {
    return {
      current: vuetifyLanguageFromCode(options === null || options === void 0 ? void 0 : options.current),
      locales: vuetifyLanguages
    };
  }
}
function vuetifyLanguageFromCode(code) {
  if (code) {
    const i = code.indexOf('-');
    const language = (i >= 0 ? code.substr(0, i) : code).toLowerCase();
    if (vuetifyLanguages[language]) {
      return language;
    }
  }
  return 'en';
}

export { Language as default };
